
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import MetricDimension, {
  Dimension,
} from "@/report/components/MetricDimension.vue"

export interface Metric {
  title: string
  name1: string
  name2: string
  dimension1: Dimension
  dimension2: Dimension
}

@Component({
  components: {MetricDimension},
})
export default class MetricSquare extends Vue {
  @Prop({required: true})
  metric: Metric
}
